export default __webpack_public_path__ + "static/media/route_opt.20a5bcd8.png";